



































































































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
import { format as formatDate } from "date-fns";
// project
import { useAssets } from "@/hooks/useAssets";
import { useTags } from "@/hooks/useTags";
import { Dictionary } from "@/utils/types";
// import { formatDateStringRecent } from "@/utils/text";
import { getAssetTypes } from "@/psychlab/meta";
import { getInverseColor } from "@/utils/color";
import { useRecentAssets } from "./useRecentAssets";

const config = {
	colors:{
		"Form":"#9471fe",
		"Select":"white",
		"Scene":"#0a9931",
		"CognitiveTest":"#00bdd6",
		"Gallery":"#f07705",
		"Start":"white",
		"empty":"black",
		"Graph":"#117a8b"
	} as Dictionary<string>,
	icons:{
		"Form":"mdi.file-document-edit text-dark",
		"Select":"mdi.arrow-decision mdi-rotate-180 text-dark",
		"Scene":"mdi.rotate-3d text-dark",
		"CognitiveTest":"mdi.head-cog mdi-flip-h text-dark",
		"Gallery":"mdi.image-multiple text-dark",
		"Start":"mdi.flash text-dark",
	} as Dictionary<string>
};

const assetTypes:any = {};
getAssetTypes().forEach(at => assetTypes[at.name] = at);

export default defineComponent({
	setup(props){

		const assetHooks = useAssets();

		const tagHooks = useTags();

		const days = computed(() => 7);

		const {
			assets
		} = useRecentAssets(days);

		const getTypeIcon = (t:string) => {
			return assetTypes[t] ? assetTypes[t].icon : "mdi.circle-outline";
		};

		const getAssetRoute = (id:string) => {
			return {
				name:"view-asset",
				params:{
					assetId:id
				}
			}
		};

		const getLabelColor = (bgColor:string) => {
			return getInverseColor(bgColor);
		}
		
		const getAssetTags = (id:string) => {
			return tagHooks.getItemTags(id);
		};
		
		const formatDisplayDate = (v:string) => {
			return formatDate(new Date(v), "eeee MMM d y @ HH:mm");
		};

		const getTypeColor = (t:string) => {
			return config.colors[t] || "transparent";
		};


		return {
			assets,
			// formatDateStringRecent,
			getTypeIcon,
			getAssetRoute,
			getAssetTags,
			getLabelColor,
			days,
			formatDisplayDate,
			getTypeColor,
		};
	}
});

